import { setSearchTextForSuggestion } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setSearchTextForSuggestion, function (actionMessage) {
    getStore().searchTextForSuggestion = actionMessage.searchTextForSuggestion;
});
//# sourceMappingURL=setSearchTextForSuggestionMutator.js.map